import { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import './FalconPage.css';

const LAWYER_IMAGE_SRC = '/img/patriciaProfileWeb.png';
const WHATSAPP_URL = 'https://wa.me/5491132361805';
const FORMSPREE_ACTION = 'https://formspree.io/f/xreyolap';

const TRUST_LOGOS = [
  { src: '/img/nacion.png', alt: 'La Nación' },
  { src: '/img/telefe.png', alt: 'Telefe' },
  { src: '/img/clarin.png', alt: 'Clarín' },
];

const SERVICE_SUMMARY_KEYS = [
  { listKey: 'amparos', summaryKey: 'svcAmparos' },
  { listKey: 'derechos', summaryKey: 'svcDerechos' },
  { listKey: 'sucesiones', summaryKey: 'svcSucesiones' },
  { listKey: 'familyLaw', summaryKey: 'svcFamily' },
  { listKey: 'ciudadania', summaryKey: 'svcCiudadania' },
];

function FalconPage() {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  return (
    <div className="falcon-page">
      <section className="falcon-hero" aria-label="Patricia Falcon Abogados">
        <div className="falcon-hero__top">
          <a href="tel:+5491132361805" className="falcon-hero__phone-bar">
            {t('ley.phoneDisplay')}
          </a>
        </div>

        <div className="falcon-hero__inner">
          <div className="falcon-hero__left">
            <div className="falcon-hero__brand">
              <img src="/img/pfalconlogo.png" alt="" className="falcon-hero__brand-img" />
              <div className="falcon-hero__brand-text">
                <span className="falcon-hero__patricia">PATRICIA</span>
                <span className="falcon-hero__falcon">FALCON</span>
                <span className="falcon-hero__abogados">ABOGADOS</span>
              </div>
            </div>

            <h1 className="falcon-hero__headline">{t('hero.title')}</h1>
            <p className="falcon-hero__subtitle">{t('hero.subtitle')}</p>

            <p className="falcon-hero__endorsement">
              <span className="falcon-hero__endorse-voted">{t('ley.endorsementVoted')}</span>{' '}
              <span className="falcon-hero__endorse-best">{t('ley.endorsementBest')}</span>{' '}
              <span className="falcon-hero__endorse-rest">{t('ley.endorsementRest')}</span>
            </p>

            <div className="falcon-hero__visual">
              <img src={LAWYER_IMAGE_SRC} alt="" className="falcon-hero__visual-img" />
            </div>

            <p className="falcon-hero__trust-label">{t('falcon.asSeenOn')}</p>
            <div className="falcon-hero__trust-logos" role="list">
              {TRUST_LOGOS.map(({ src, alt }) => (
                <div key={src} className="falcon-hero__trust-item" role="listitem">
                  <img src={src} alt={alt} className="falcon-hero__trust-img" />
                </div>
              ))}
            </div>
            <p className="falcon-hero__trusted-headline">{t('trustedBy.headline')}</p>
          </div>

          <aside className="falcon-hero__aside">
            <div className="falcon-form-card">
              <h2 className="falcon-form-card__title">{t('falcon.formCardTitle')}</h2>
              <form className="falcon-form" action={FORMSPREE_ACTION} method="POST">
                <label className="falcon-form__label">
                  {t('ley.formNameLabel')}<span className="falcon-form__req">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  required
                  className="falcon-form__input"
                  placeholder={t('ley.formNamePlaceholder')}
                  value={formData.name}
                  onChange={handleChange}
                />
                <label className="falcon-form__label">
                  {t('ley.formEmailLabel')}<span className="falcon-form__req">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  className="falcon-form__input"
                  placeholder={t('ley.formEmailPlaceholder')}
                  value={formData.email}
                  onChange={handleChange}
                />
                <label className="falcon-form__label">{t('ley.formPhoneLabel')}</label>
                <input
                  type="tel"
                  name="phone"
                  className="falcon-form__input"
                  placeholder={t('ley.formPhonePlaceholder')}
                  value={formData.phone}
                  onChange={handleChange}
                />
                <label className="falcon-form__label">{t('ley.formMessageLabel')}</label>
                <textarea
                  name="message"
                  className="falcon-form__textarea"
                  placeholder={t('ley.formMessagePlaceholder')}
                  rows={4}
                  value={formData.message}
                  onChange={handleChange}
                />
                <button type="submit" className="falcon-form__submit">
                  {t('ley.formSubmit')}
                </button>
              </form>
            </div>
          </aside>
        </div>
      </section>

      <section className="falcon-stats" aria-labelledby="falcon-stats-heading">
        <div className="falcon-stats__inner">
          <h2 id="falcon-stats-heading" className="falcon-stats__title">
            {t('ley.statsTitle')}
          </h2>
          <p className="falcon-stats__reviews">{t('ley.statsReviews')}</p>
          <div className="falcon-stats__stars" aria-hidden="true">
            {[1, 2, 3, 4, 5].map((i) => (
              <span key={i} className="falcon-stats__star" />
            ))}
          </div>
          <p className="falcon-stats__winning">{t('ley.statsWinning')}</p>
        </div>
      </section>

      <section className="falcon-cta">
        <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="falcon-cta__btn">
          <span className="falcon-cta__label">{t('ley.ctaLabel')}</span>
          <span className="falcon-cta__sub">{t('ley.ctaSublabel')}</span>
        </a>
      </section>

      <section className="falcon-services" aria-labelledby="falcon-services-heading">
        <div className="falcon-services__inner">
          <span className="falcon-services__label">{t('services.label')}</span>
          <h2 id="falcon-services-heading" className="falcon-services__title">
            {t('falcon.servicesSummaryTitle')}
          </h2>
          <p className="falcon-services__intro">{t('falcon.servicesSummaryIntro')}</p>
          <div className="falcon-services__grid">
            {SERVICE_SUMMARY_KEYS.map(({ listKey, summaryKey }) => (
              <article key={listKey} className="falcon-services__card">
                <h3 className="falcon-services__card-title">{t(`servicesList.${listKey}.title`)}</h3>
                <p className="falcon-services__card-text">{t(`falcon.${summaryKey}`)}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default FalconPage;
